export const isCSRAdmin = (csrUser) => {
  return csrUser?.role?.roleName?.toLowerCase() === "csr admin";
};
